<template>
  <!-- SECCIÓN DISTRIBUCIÓN -->
  <v-card flat color="transparent" class="pa-4">
    <template v-slot:title>
      <div class="d-flex align-center justify-space-between">
        <span>{{ t("labels.distribution") }}</span>
        <v-btn
          icon="mdi-refresh"
          density="comfortable"
          variant="text"
          :loading="loading"
          @click="fetchAllData"
        ></v-btn>
      </div>
    </template>

    <template v-slot:text>
      <v-text-field
        v-model="searchDistribucion"
        :label="t('buttons.search')"
        prepend-inner-icon="mdi-magnify"
        variant="outlined"
        hide-details
        single-line
        density="compact"
        style="max-width: 400px"
      ></v-text-field>
    </template>

    <v-data-table
      :headers="headersDistribucion"
      :items="finalItemsDistri"
      :search="searchDistribucion"
      :loading="loading"
      color="blue"
      hover
      @click:row="showDialog"
    >
      <!-- Cabecera arrastrable para Distribución -->
      <template v-slot:headers="{ isSorted, getSortIcon, toggleSort }">
        <tr>
          <th
            v-for="(header, index) in headersDistribucion"
            :key="header.key"
            draggable="true"
            class="cursor-grab header-cell"
            @dragstart="onDragStart(index)"
            @dragover.prevent
            @drop="onDrop(index, headersDistribucion)"
            @click="toggleSort(header)"
          >
            <div class="d-flex align-center justify-space-between">
              <span>{{ header.title }}</span>
              <v-icon v-if="isSorted(header)">{{ getSortIcon(header) }}</v-icon>
            </div>
          </th>
        </tr>
      </template>

      <!-- Rendimiento visual optimizado para celdas -->
      <template v-slot:item.latencia="{ value }">
        <div class="d-flex align-center justify-center ga-2 px-2">
          <span class="value-label">{{ value }}</span>
          <v-progress-linear
            bg-color="pink-lighten-3"
            :color="getLatencyColor(value)"
            model-value="100"
            height="10"
            rounded
            class="flex-grow-1"
          ></v-progress-linear>
        </div>
      </template>

      <template v-slot:item.snr_v="{ value }">
        <div class="d-flex align-center justify-center ga-2 px-2">
          <span class="value-label">{{ value }}</span>
          <v-progress-linear
            bg-color="pink-lighten-3"
            :color="getSNRColor(value)"
            model-value="100"
            height="10"
            rounded
            class="flex-grow-1"
          ></v-progress-linear>
        </div>
      </template>

      <template v-slot:item.snr_h="{ value }">
        <div class="d-flex align-center justify-center ga-2 px-2">
          <span class="value-label">{{ value }}</span>
          <v-progress-linear
            bg-color="pink-lighten-3"
            :color="getSNRColor(value)"
            model-value="100"
            height="10"
            rounded
            class="flex-grow-1"
          ></v-progress-linear>
        </div>
      </template>

      <template v-slot:item.rxh="{ value }">
        <div class="d-flex align-center justify-center ga-2 px-2">
          <span class="value-label">{{ value }}</span>
          <v-progress-linear
            bg-color="pink-lighten-3"
            :color="getRXColor(value)"
            model-value="100"
            height="10"
            rounded
            class="flex-grow-1"
          ></v-progress-linear>
        </div>
      </template>

      <template v-slot:item.rxv="{ value }">
        <div class="d-flex align-center justify-center ga-2 px-2">
          <span class="value-label">{{ value }}</span>
          <v-progress-linear
            bg-color="pink-lighten-3"
            :color="getRXColor(value)"
            model-value="100"
            height="10"
            rounded
            class="flex-grow-1"
          ></v-progress-linear>
        </div>
      </template>
    </v-data-table>
  </v-card>

  <!-- SECCIÓN ACCESO -->
  <v-card flat color="transparent" class="pa-4">
    <template v-slot:title>
      <div class="d-flex align-center justify-space-between">
        <span>{{ t("labels.access") }}</span>
        <v-btn
          icon="mdi-refresh"
          density="comfortable"
          variant="text"
          :loading="loading"
          @click="fetchAllData"
        ></v-btn>
      </div>
    </template>

    <template v-slot:text>
      <v-text-field
        v-model="searchAcceso"
        :label="t('buttons.search')"
        prepend-inner-icon="mdi-magnify"
        variant="outlined"
        hide-details
        single-line
        density="compact"
        style="max-width: 400px"
      ></v-text-field>
    </template>

    <v-data-table
      :headers="headersAcceso"
      :items="finalItemsAcceso"
      :search="searchAcceso"
      :loading="loading"
      color="blue"
      hover
      @click:row="showDialog"
    >
      <!-- Cabecera arrastrable para Acceso -->
      <template v-slot:headers="{ isSorted, getSortIcon, toggleSort }">
        <tr>
          <th
            v-for="(header, index) in headersAcceso"
            :key="header.key"
            draggable="true"
            class="cursor-grab header-cell"
            @dragstart="onDragStart(index)"
            @dragover.prevent
            @drop="onDrop(index, headersAcceso)"
            @click="toggleSort(header)"
          >
            <div class="d-flex align-center justify-space-between">
              <span>{{ header.title }}</span>
              <v-icon v-if="isSorted(header)">{{ getSortIcon(header) }}</v-icon>
            </div>
          </th>
        </tr>
      </template>

      <template v-slot:item.temperatura="{ value }">
        <div class="d-flex align-center justify-center ga-2 px-2">
          <span class="value-label">{{ value }} °C</span>
          <v-progress-linear
            bg-color="pink-lighten-3"
            :color="getTemperatureColor(value)"
            model-value="100"
            height="10"
            rounded
            class="flex-grow-1"
          ></v-progress-linear>
        </div>
      </template>

      <template v-slot:item.voltaje="{ value }">
        <div class="d-flex align-center justify-center ga-2 px-2">
          <span class="value-label">{{ value }} V</span>
          <v-progress-linear
            bg-color="pink-lighten-3"
            :color="getVoltajeColor(value)"
            model-value="100"
            height="10"
            rounded
            class="flex-grow-1"
          ></v-progress-linear>
        </div>
      </template>

      <template v-slot:item.cost="{ value }">
        <div class="d-flex align-center justify-center ga-2 px-2">
          <span class="value-label">{{ value }}</span>
          <v-progress-linear
            bg-color="pink-lighten-3"
            :color="getCostColor(value)"
            model-value="100"
            height="10"
            rounded
            class="flex-grow-1"
          ></v-progress-linear>
        </div>
      </template>

      <template v-slot:item.latencia="{ value }">
        <div class="d-flex align-center justify-center ga-2 px-2">
          <span class="value-label">{{ value }}</span>
          <v-progress-linear
            bg-color="pink-lighten-3"
            :color="getLatencyColor(value)"
            model-value="100"
            height="10"
            rounded
            class="flex-grow-1"
          ></v-progress-linear>
        </div>
      </template>
    </v-data-table>
  </v-card>

  <!-- SECCIÓN CLIENTE -->
  <v-card flat color="transparent" class="pa-4">
    <template v-slot:title>
      <div class="d-flex align-center justify-space-between">
        <span>{{ t("labels.client") }}</span>
        <v-btn
          icon="mdi-refresh"
          density="comfortable"
          variant="text"
          :loading="loading"
          @click="fetchAllData"
        ></v-btn>
      </div>
    </template>

    <template v-slot:text>
      <v-text-field
        v-model="searchClient"
        :label="t('buttons.search')"
        prepend-inner-icon="mdi-magnify"
        variant="outlined"
        hide-details
        single-line
        density="compact"
        style="max-width: 400px"
      ></v-text-field>
    </template>

    <v-data-table
      :headers="headersCliente"
      :items="finalItemsClient"
      :search="searchClient"
      :loading="loading"
      color="blue"
      hover
      @click:row="showDialog"
    >
      <!-- Cabecera arrastrable para Cliente -->
      <template v-slot:headers="{ isSorted, getSortIcon, toggleSort }">
        <tr>
          <th
            v-for="(header, index) in headersCliente"
            :key="header.key"
            draggable="true"
            class="cursor-grab header-cell"
            @dragstart="onDragStart(index)"
            @dragover.prevent
            @drop="onDrop(index, headersCliente)"
            @click="toggleSort(header)"
          >
            <div class="d-flex align-center justify-space-between">
              <span>{{ header.title }}</span>
              <v-icon v-if="isSorted(header)">{{ getSortIcon(header) }}</v-icon>
            </div>
          </th>
        </tr>
      </template>

      <template v-slot:item.temperatura="{ value }">
        <div class="d-flex align-center justify-center ga-2 px-2">
          <span class="value-label">{{ value }} °C</span>
          <v-progress-linear
            bg-color="pink-lighten-3"
            :color="getTemperatureColor(value)"
            model-value="100"
            height="10"
            rounded
            class="flex-grow-1"
          ></v-progress-linear>
        </div>
      </template>

      <template v-slot:item.voltaje="{ value }">
        <div class="d-flex align-center justify-center ga-2 px-2">
          <span class="value-label">{{ value }} V</span>
          <v-progress-linear
            bg-color="pink-lighten-3"
            :color="getVoltajeColor(value)"
            model-value="100"
            height="10"
            rounded
            class="flex-grow-1"
          ></v-progress-linear>
        </div>
      </template>

      <template v-slot:item.cost="{ value }">
        <div class="d-flex align-center justify-center ga-2 px-2">
          <span class="value-label">{{ value }}</span>
          <v-progress-linear
            bg-color="pink-lighten-3"
            :color="getCostColor(value)"
            model-value="100"
            height="10"
            rounded
            class="flex-grow-1"
          ></v-progress-linear>
        </div>
      </template>

      <template v-slot:item.latencia="{ value }">
        <div class="d-flex align-center justify-center ga-2 px-2">
          <span class="value-label">{{ value }}</span>
          <v-progress-linear
            bg-color="pink-lighten-3"
            :color="getLatencyColor(value)"
            model-value="100"
            height="10"
            rounded
            class="flex-grow-1"
          ></v-progress-linear>
        </div>
      </template>
    </v-data-table>
  </v-card>

  <!-- DIALOG COMPONENT -->
  <v-dialog v-model="dialog" width="85%">
    <DialogComponent
      v-if="dialog"
      :ip="selectedIp"
      :typeSel="selectedType"
      :name="selectedName"
      :modelo="selectedModel"
      @dialog="closeDialog"
      :status="'Ok'"
    />
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from "@/constants/labels";
import { COLOR } from "@/constants/colors";

/********************************
 *********** SERVICES ***********
 *******************************/
import {
  getAllLatencyData,
  getAllQualityData,
  getAllRajantData,
  getAllSensoresData,
} from "@/services/Smartlink/KPI";

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from "vuex";
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from "vue-i18n";
const { t } = useI18n();

/********************************
 ********** COMPONENTES *********
 *******************************/
import DialogComponent from "@/components/SmartLink/dialog/dialogComponent.vue";

// FUNCIONES DE COLORES
function getVoltajeColor(voltaje: number): string {
  if (voltaje < 5000 && voltaje > 0) return COLOR.green;
  if (voltaje >= 5000 && voltaje < 10000) return COLOR.yellow;
  if (voltaje >= 10000) return COLOR.red;
  return COLOR.grey;
}

function getTemperatureColor(temperature: number): string {
  if (temperature <= 30) return COLOR.green;
  if (temperature > 30 && temperature <= 60) return COLOR.yellow;
  if (temperature > 60 && temperature <= 70) return COLOR.warning;
  return COLOR.red;
}

function getCostColor(cost: number): string {
  if (cost < 5000) return COLOR.green;
  if (cost >= 5000 && cost < 10000) return COLOR.yellow;
  return COLOR.red;
}

function getLatencyColor(latency: number): string {
  if (latency < 100 && latency >= 0) return COLOR.green;
  if (latency >= 100 && latency < 200) return COLOR.yellow;
  if (latency >= 200) return COLOR.red;
  return COLOR.grey;
}

function getSNRColor(snr: number): string {
  if (snr < 16 && snr >= 0) return COLOR.red;
  if (snr >= 16 && snr < 20) return COLOR.yellow;
  if (snr >= 20) return COLOR.green;
  return COLOR.grey;
}

function getRXColor(rx: number): string {
  if (rx < 0 && rx >= -65) return COLOR.green;
  if (rx >= -75 && rx < -65) return COLOR.yellow;
  if (rx < -75) return COLOR.red;
  return COLOR.grey;
}

// BÚSQUEDAS
const searchDistribucion = ref("");
const searchAcceso = ref("");
const searchClient = ref("");

// ENCABEZADOS INDEPENDIENTES PARA PERMITIR ARRASTRAR DE FORMA INDIVIDUAL
const headersAcceso = ref([
  { key: "name", title: t("labels.equipment"), sortable: true },
  { key: "ip", title: "IP", sortable: true },
  { key: "tipo", title: `${t("labels.type")}`, sortable: true },
  { key: "latencia", title: `${t("labels.latency")} (ms)`, sortable: true },
  { key: "cost", title: t("labels.cost"), sortable: true },
  { key: "temperatura", title: `${t("labels.temperature")} (°C)`, sortable: true },
  { key: "voltaje", title: `${t("labels.voltage")} (Volt)`, sortable: true },
]);

const headersCliente = ref([
  { key: "name", title: t("labels.equipment"), sortable: true },
  { key: "ip", title: "IP", sortable: true },
  { key: "tipo", title: `${t("labels.type")}`, sortable: true },
  { key: "latencia", title: `${t("labels.latency")} (ms)`, sortable: true },
  { key: "cost", title: t("labels.cost"), sortable: true },
  { key: "temperatura", title: `${t("labels.temperature")} (°C)`, sortable: true },
  { key: "voltaje", title: `${t("labels.voltage")} (Volt)`, sortable: true },
]);

const headersDistribucion = ref([
  { key: "name", title: t("labels.equipment"), sortable: true },
  { key: "ip", title: "IP", sortable: true },
  { key: "tipo", title: `${t("labels.type")}`, sortable: true },
  { key: "latencia", title: `${t("labels.latency")} (ms)`, sortable: true },
  { key: "snr_v", title: `${t("labels.snrVerti")} (dB)`, sortable: true },
  { key: "snr_h", title: `${t("labels.snrHoriz")} (dB)`, sortable: true },
  { key: "rxh", title: `${t("labels.rxHoriz")} (dBm)`, sortable: true },
  { key: "rxv", title: `${t("labels.rxVerti")} (dBm)`, sortable: true },
]);

// ESTADOS DRAG & DROP
const draggedIndex = ref<number | null>(null);

function onDragStart(index: number) {
  draggedIndex.value = index;
}

function onDrop(targetIndex: number, headersArray: any[]) {
  if (draggedIndex.value === null || draggedIndex.value === targetIndex) return;
  const movedHeader = headersArray.splice(draggedIndex.value, 1)[0];
  headersArray.splice(targetIndex, 0, movedHeader);
  draggedIndex.value = null;
}

// ESTADOS DE DATOS
const latencyItems = ref<any[]>([]);
const costItems = ref<any[]>([]);
const sensoresItems = ref<any[]>([]);
const qualityItems = ref<any[]>([]);
const finalItemsDistri = ref<any[]>([]);
const finalItemsAcceso = ref<any[]>([]);
const finalItemsClient = ref<any[]>([]);

const loading = ref(false);
let refreshInterval: ReturnType<typeof setInterval> | null = null;

async function getDataLatencyTable() {
  const allData = await getAllLatencyData();
  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    latencyItems.value = allData.data;
  }
}

async function getDataCostTable() {
  const allData = await getAllRajantData();
  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    costItems.value = allData.data;
  }
}

async function getDataSensoresTable() {
  const allData = await getAllSensoresData();
  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    sensoresItems.value = allData.data;
  }
}

async function getDataQualityTable() {
  const allData = await getAllQualityData();
  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    qualityItems.value = allData.data;
  }
}

async function combineData() {
  finalItemsDistri.value = [];
  finalItemsAcceso.value = [];
  finalItemsClient.value = [];

  latencyItems.value.forEach((item) => {
    const costItem = costItems.value[item.ip];
    const sensorItem = sensoresItems.value[item.ip];
    const qualityItem = qualityItems.value[item.ip];

    const modelo = item.anotacion ?? { model: "-" };

    const finalObj = {
      ip: item.ip,
      name: `${item.name} - ${modelo.model ?? "-"}`,
      modelo: modelo,
      tipo: item.tipo,
      latencia: item.latencia,
      cost: costItem ? costItem.cost : 0,
      temperatura: sensorItem ? sensorItem.temperatura : 0,
      voltaje: sensorItem ? sensorItem.voltaje : 0,
      snr_v: qualityItem ? qualityItem.snr_v : 0,
      snr_h: qualityItem ? qualityItem.snr_h : 0,
      avgpower: qualityItem ? qualityItem.avgpower : 0,
      rxh: qualityItem ? qualityItem.rxh : 0,
      rxv: qualityItem ? qualityItem.rxv : 0,
    };

    if (
      item.subtipo === "Distribución" ||
      item.subtipo === "Distribucion" ||
      item.subtipo === "Distribution"
    ) {
      finalItemsDistri.value.push(finalObj);
    }
    if (item.subtipo === "Acceso") {
      finalItemsAcceso.value.push(finalObj);
    }
    if (item.subtipo === "Cliente") {
      finalItemsClient.value.push(finalObj);
    }
  });
}

// PETICIÓN Y REFRESCAMIENTO DE DATOS
async function fetchAllData() {
  loading.value = true;
  await Promise.all([
    getDataLatencyTable(),
    getDataCostTable(),
    getDataSensoresTable(),
    getDataQualityTable(),
  ]);
  await combineData();
  loading.value = false;
}

// DIALOG
const dialog = ref(false);
const selectedIp = ref("");
const selectedName = ref("");
const selectedType = ref("");
const selectedModel = ref("");

function showDialog(event: any, { item }: any) {
  selectedIp.value = item.ip ?? "";
  selectedType.value = item.tipo ?? "";
  selectedName.value = item.name ?? "";
  selectedModel.value = item.model
  dialog.value = true;
}

function closeDialog() {
  dialog.value = false;
}

// CICLO DE VIDA
onMounted(async () => {
  await fetchAllData();
  // Consulta automática cada 1 minuto (60.000 ms)
  refreshInterval = setInterval(() => {
    fetchAllData();
  }, 60000);
});

onUnmounted(() => {
  if (refreshInterval) clearInterval(refreshInterval);
});
</script>

<style scoped>
.v-table {
  background-color: transparent !important;
}

/* Drag & Drop Styles */
.cursor-grab {
  cursor: grab !important;
  user-select: none;
}

.cursor-grab:active {
  cursor: grabbing !important;
}

.header-cell {
  transition: background-color 0.2s ease;
  padding: 0 16px !important;
}

.header-cell:hover {
  background-color: rgba(var(--v-theme-on-surface), 0.04);
}

/* Column cell layout optimization */
.value-label {
  min-width: 55px;
  text-align: right;
  font-weight: 500;
  font-size: 0.875rem;
}
</style>